import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/attendance-core/_layout/config/')({
  component: () => null
});